import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiTrendingUp, FiTrendingDown, FiMinus, FiAlertTriangle } from 'react-icons/fi';
import './CourseHealthCard.css';

const trendConfig = {
  improving: { icon: FiTrendingUp, color: '#22c55e', label: 'Improving' },
  declining: { icon: FiTrendingDown, color: '#ef4444', label: 'Declining' },
  stable: { icon: FiMinus, color: '#64748b', label: 'Stable' },
};

const riskConfig = {
  watch: { color: '#f59e0b', label: 'Watch' },
  important: { color: '#ef4444', label: 'Needs Attention' },
};

function CourseHealthCard({ course }) {
  const navigate = useNavigate();
  const trend = trendConfig[course.trend] || trendConfig.stable;
  const TrendIcon = trend.icon;
  const risk = course.riskLabel ? riskConfig[course.riskLabel] : null;

  return (
    <div
      className="course-health-card"
      onClick={() => navigate(`/parent/courses/${course.id}`)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter') navigate(`/parent/courses/${course.id}`); }}
      aria-label={`${course.name} - ${course.completionRate}% complete`}
    >
      <div className="course-health-card__header">
        <h4 className="course-health-card__name">{course.name}</h4>
        {risk && (
          <span className="course-health-card__risk" style={{ color: risk.color, background: `${risk.color}15` }}>
            <FiAlertTriangle size={11} />
            {risk.label}
          </span>
        )}
      </div>

      <span className="course-health-card__instructor">{course.instructor}</span>

      <div className="course-health-card__progress">
        <div className="course-health-card__progress-bar">
          <div
            className="course-health-card__progress-fill"
            style={{ width: `${course.completionRate}%` }}
          />
        </div>
        <span className="course-health-card__progress-label">{course.completionRate}%</span>
      </div>

      <div className="course-health-card__footer">
        <div className="course-health-card__stats">
          <span>{course.upcomingAssignments} upcoming</span>
          {course.overdueAssignments > 0 && (
            <span className="course-health-card__overdue">{course.overdueAssignments} overdue</span>
          )}
        </div>
        <div className="course-health-card__trend" style={{ color: trend.color }}>
          <TrendIcon size={14} />
          <span>{trend.label}</span>
        </div>
      </div>
    </div>
  );
}

export default CourseHealthCard;
